import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Build",
    copy: "Find a real problem worth solving.",
    testId: "philosophy-chapter-build",
  },
  {
    num: "02",
    title: "Make",
    copy: "Turn the idea into a useful, well-designed product.",
    testId: "philosophy-chapter-make",
  },
  {
    num: "03",
    title: "Win",
    copy: "Create something people value enough to keep using.",
    testId: "philosophy-chapter-win",
  },
];

export const Philosophy = () => (
  <section
    id="philosophy"
    data-testid="philosophy-section"
    className="border-y border-ink/5 bg-white"
  >
    <div className="mx-auto max-w-[1240px] px-4 py-20 sm:px-6 lg:px-8 lg:py-32">
      <Reveal>
        <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-growth sm:text-sm">
          How we work
        </p>
        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
          Build the right things.
        </h2>
        <p className="mt-5 max-w-[680px] font-body text-lg leading-relaxed text-slate">
          We start with work people already do and ask one practical question: how can this be
          noticeably better?
        </p>
      </Reveal>

      <div className="mt-16 grid gap-px overflow-hidden rounded-[20px] border border-ink/10 bg-ink/10 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12} className="bg-white">
            <div
              data-testid={c.testId}
              className="group flex h-full flex-col gap-6 p-8 transition-colors duration-300 hover:bg-cream lg:p-10"
            >
              <span className="font-display text-5xl font-semibold tracking-tight text-sage transition-colors duration-300 group-hover:text-growth lg:text-6xl">
                {c.num}
              </span>
              <div>
                <h3 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-evergreen">
                  {c.title}
                </h3>
                <p className="mt-3 font-body text-lg leading-relaxed text-ink/90">{c.copy}</p>
              </div>
              <span className="mt-auto block h-px w-full bg-ink/10">
                <span className="block h-px w-0 bg-growth transition-all duration-500 group-hover:w-full" />
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mx-auto mt-16 max-w-[760px] text-center font-display text-2xl font-medium leading-snug tracking-tight text-evergreen sm:text-3xl">
          Useful beats complicated. Real problems beat invented ones. Ship, learn, improve.
        </p>
      </Reveal>
    </div>
  </section>
);
